import { render, staticRenderFns } from "./onZinn.vue?vue&type=template&id=9425e65e"
import script from "./onZinn.vue?vue&type=script&lang=js"
export * from "./onZinn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports